/** Shared date helpers for public campaign UI (listing + detail). */

export function campaignEnded(endDate: string | null): boolean {
  if (!endDate) return false
  const end = new Date(endDate + "T12:00:00")
  end.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return end < today
}

export function daysRemaining(endDate: string | null): number | null {
  if (!endDate) return null
  const end = new Date(endDate + "T12:00:00")
  end.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return Math.ceil((end.getTime() - today.getTime()) / 86400000)
}
